import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={16.454}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 22467 35094"
    {...props}
  >
    <path
      d="M17928 19287c-1372 1143-2138 2716-2230 4569h-3093v-6619l3236-7513c163-380-314-712-613-427l-803 762-802-762c-147-140-378-139-526 0l-801 762-801-762c-147-140-378-140-525 0l-801 762-801-762c-148-139-379-140-526 0l-801 762-801-762c-300-286-777 48-613 428l3235 7512v6619H6770c-92-1853-859-3426-2230-4569-2601-2165-3970-5348-3755-8733C1133 5065 5723 765 11234 763c5510 2 10100 4302 10448 9791 215 3385-1153 6568-3754 8733zm-7303-1748h1217v6317h-1217v-6317zm1347-762h-1477l-2504-5814c111 14 226-19 312-101l801-762 802 762c147 139 378 139 525 0l802-762 801 762c147 139 378 139 525 0l802-762 802 762c87 82 202 116 314 101l-2505 5814zm-5193 8738v-896h8909v896H6779zm8909 1677H6779v-914h8909v914zm0 1677H6779v-914h8909v914zm0 1676H6779v-914h8909v914zm-1278 1660H8057c-572 0-1057-378-1219-897h8792c-163 519-648 897-1220 897zm-1906 2126H9963l-566-1363h3673l-566 1363zm9940-23825C22070 4617 17146 2 11234 0 5321 2 397 4617 24 10506c-230 3630 1237 7045 4027 9368 1286 1070 1965 2579 1965 4363v1278h-240c-211 0-382 171-382 381 0 211 171 382 382 382h240v914h-240c-211 0-382 171-382 382 0 210 171 381 382 381h240v914h-240c-211 0-382 170-382 381s171 382 382 382l240-1v914h-240c-211 0-382 171-382 382s171 381 382 381h277c180 944 1010 1660 2004 1660h515l784 1891c59 142 198 235 352 235h3051c155 0 293-93 353-235l784-1891h514c995 0 1825-716 2004-1660h278c211 0 381-170 381-381s-171-382-381-382h-241v-914h241c211 0 381-170 381-381s-171-381-381-381h-241v-914h241c211 0 381-171 381-381 0-211-171-382-381-382h-241v-914h241c211 0 381-171 381-382 0-210-171-381-381-381h-241v-1278c0-1784 680-3293 1965-4363 2790-2323 4258-5738 4028-9368z"
      style={{
        fill: "#2b2a29",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
